module.exports = __webpack_public_path__ + "img/quincho-parrilla.31925757.svg";